<script>
import { onMounted, ref } from 'vue'

export default {
  setup(props, {slots}) {

    const products = ref(null)

    onMounted(async () => {
      while(!window._swat) {
        await new Promise(resolve => setTimeout(resolve, 200));
      }
      setTimeout(() => {
        loadProducts()
      }, 300)
    })

    const loadProducts = () => {
      window._swat.fetchWrtEventTypeET( (wishlistItems) => {
        products.value = wishlistItems
      }, window._swat.EventTypes.addToWishlist);
    }

    return () => slots.default({
      products: products.value
    })
  }
}
</script>